import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'Components/Modal';
import { fetchWaylensClip } from './redux/slice';
import { useIntl } from 'react-intl';

function buildWaylensPlayerUrl(mp4Url, startTime, rawDataUrl) {
  const base = 'https://data.waylens.com/rawplayer';
  const params = [
    `playurl=${encodeURIComponent(btoa(mp4Url))}`,
    rawDataUrl ? `rawdata_url=${encodeURIComponent(btoa(rawDataUrl))}` : null,
    `startime=${startTime ?? 0}`,
    'dewarp=false',
    'isUSD=false',
    'gpstimeoffset=0',
    'hideDashboard=false',
    'hideSidebar=false',
    'speedUnit=mph',
  ]
    .filter(Boolean)
    .join('&');
  return `${base}?${params}`;
}

const WaylensPlayerModal = ({ open, onClose, clipId }) => {
  const dispatch = useDispatch();
  const { messages } = useIntl();

  const clip = useSelector((state) => clipId ? (state.waylensClipRedux?.clips?.[clipId] ?? null) : null);
  const isFetching = useSelector((state) => clipId ? (state.waylensClipRedux?.loading?.[clipId] ?? false) : false);

  useEffect(() => {
    if (open && clipId) {
      dispatch(fetchWaylensClip({ clipId }));
    }
  }, [open, clipId]);

  const iframeUrl = useMemo(() => {
    if (!clip?.mp4Url) return null;
    return buildWaylensPlayerUrl(clip.mp4Url, clip.startTime, clip.rawDataURL ?? undefined);
  }, [clip]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      handleClose={onClose}
      size="large"
      header={false}
    >
      <Box
        style={{
          position: 'relative',
          width: '100%',
          height: '680px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          onClick={onClose}
          size="small"
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: '#fff',
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        {isFetching ? (
          <CircularProgress />
        ) : iframeUrl ? (
          <iframe
            key={iframeUrl}
            style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
            src={iframeUrl}
            title="Waylens Video Player"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            allowFullScreen
          />
        ) : (
          <Typography>
            {messages['videoMainView_noVideoAvailable'] || 'No video available for this event'}
          </Typography>
        )}
      </Box>
    </Modal>
  );
};

export default WaylensPlayerModal;
